import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Action, compose } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { fetchNotification, markAsRead } from 'redux/actions/notifications';
import { fetchContent } from '../../redux/actions/contentful';
import { AppState } from '../../types/redux';
import Home from './Home';

const mapStateToProps = (state: AppState) => ({
	notificationCode: state.notification.code,
	notificationMessage: state.notification.message,
});

/* istanbul ignore next */
const mapDispatchToProps = (
	dispatch: ThunkDispatch<Promise<any>, void, Action>
) => ({
	fetchNotification: () => {
		dispatch(fetchNotification());
	},
	fetchContent: () => {
		dispatch(fetchContent());
	},
	markAsRead: () => {
		dispatch(markAsRead());
	},
});

export default compose<typeof Home>(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(Home);
